
export const FORMATS_NAMES = {
  eu: {
    1: "240304 (esp) Autorización de uso de imagen y voz - Grupo Spradling",
    2: "240304 (eng) Authorization for the use of image and voice - Spradling Group",
  },
  mx: "240313 (esp) Autorización de uso de imagen y voz - Spradling - México",
  us: "240304 (eng) Authorization for the use of image and voice - Spradling Group - USA",
  la: {
    1: "231114 (esp) Autorización de uso de imagen y voz - Spradling - Colombia",
    2: "231204 (esp) Autorización de uso de fotografías - Spradling - Colombia"
  }
}